export default "__VITE_ASSET__UkWDWv5j__"